<!-- Deprecated in favour of separate files for SMS and Whatsapp and also to implement new providers for each platform in the future-->
<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import axios from 'axios';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      accountSID: '',
      apiKeySID: '',
      authToken: '',
      medium: this.type,
      channelName: '',
      messagingServiceSID: '',
      useMessagingService: false,
      useAPIKey: false,
      phoneNumber: '',
      phoneNumberId: null,
      wabaId: null,
      loading: false,
      fbAuthToken: null,
    };
  },
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
    }),
    authTokeni18nKey() {
      return this.useAPIKey ? 'API_KEY_SECRET' : 'AUTH_TOKEN';
    },
  },
  validations() {
    let validations = {
      channelName: { required },

      authToken: { required },
      accountSID: { required },
      medium: { required },
    };
    if (this.phoneNumber) {
      validations = {
        ...validations,
        phoneNumber: { required, isPhoneE164OrEmpty },
        messagingServiceSID: {},
      };
    } else {
      validations = {
        ...validations,
        messagingServiceSID: { required },
        phoneNumber: {},
      };
    }

    if (this.useAPIKey) {
      validations = {
        ...validations,
        apiKeySID: { required },
      };
    }
    return validations;
  },
  mounted() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '736559528616426',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v18.0',
      });
    };

    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.defer = true;
    fbScript.crossOrigin = 'anonymous';
    fbScript.src = 'https://connect.facebook.net/en_US/sdk.js';
    document.body.appendChild(fbScript);

    window.addEventListener('message', this.embeddedSignupInfoListener);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.embeddedSignupInfoListener);
  },
  methods: {
    async createChannel() {
      try {
        const phoneNumberId = this.phoneNumberId || null;
        const wabaId = this.wabaId || null;
        const isRegisterSender = !!(phoneNumberId && wabaId);

        const twilioChannel = await this.$store.dispatch(
          'inboxes/createTwilioChannel',
          {
            twilio_channel: {
              name: this.channelName,
              medium: this.medium,
              account_sid: this.accountSID,
              api_key_sid: this.apiKeySID,
              auth_token: this.authToken,
              messaging_service_sid: this.messagingServiceSID,
              phone_number: this.messagingServiceSID
                ? null
                : `+${this.phoneNumber.replace(/\D/g, '')}`,
              is_register_sender: isRegisterSender,
              phone_number_id: this.phoneNumberId,
              waba_id: this.wabaId,
            },
          }
        );
        this.loading = false;

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: twilioChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE'));
      }
    },
    launchEmbeddedSignup() {
      // eslint-disable-next-line no-undef
      FB.login(
        response => {
          if (response.authResponse) {
            const authToken = response.authResponse.code;

            this.fbAuthToken = authToken;
          }
        },
        {
          config_id: '537880012548124',
          auth_type: 'rerequest',
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            sessionInfoVersion: 3,
            setup: {
              solutionID: '2006170563193827',
            },
          },
        }
      );
    },
    embeddedSignupInfoListener(event) {
      if (!event.origin.endsWith('facebook.com')) return;
      try {
        let data;

        try {
          data = JSON.parse(event.data);
        } catch {
          data = {};
        }
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
            const { phone_number_id, waba_id } = data.data;
            this.phoneNumberId = phone_number_id;
            this.wabaId = waba_id;
            this.loading = true;
            setTimeout(() => {
              this.createSubaccountAndRegisterSender(phone_number_id, waba_id);
            }, 2000);
          }
        }
      } catch {
        useAlert(this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE'));
      }
    },
    createSubaccountAndRegisterSender(phone_number_id, waba_id) {
      const fb_auth_token = this.fbAuthToken;
      const params = {
        phone_number_id,
        waba_id,
        fb_auth_token,
      };

      axios
        .post(
          `/api/v1/accounts/${this.currentAccountId}/channels/create_subaccount`,
          params
        )
        .then(response => {
          const { sid, auth_token, phone_number, name } = response.data;
          this.accountSID = sid;
          this.authToken = auth_token;
          this.phoneNumber = phone_number;
          this.channelName = name;

          this.createChannel().catch(() => {
            useAlert(this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE'));
          });
        })
        .catch(() => {
          useAlert(this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE'));
        });
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap mx-0">
    <button class="login-fb-button" @click.prevent="launchEmbeddedSignup">
      {{ $t('INBOX_MGMT.ADD.TWILIO.FACEBOOK_LOGIN_BUTTON') }}
    </button>

    <div v-if="loading" class="loader-overlay">
      <Spinner color-scheme="primary" />
      <span>Loading...</span>
    </div>
  </form>
</template>

<style scoped>
.login-fb-button {
  background-color: #1877f2;
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  height: 40px;
  padding: 0 24px;
  margin-top: 16px;
}

/* Loader Overlay Styles */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
</style>
